import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { Path } from '../lib/constants/path.constants';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import ProgramInfo from '../pages/ProgramInfo';
import ProgramEdit from '../pages/ProgramEdit';
import Categories from '../pages/Categories';
import Equipments from '../pages/Equipments';
import Exercises from '../pages/Exercises';
import Videos from '../pages/Videos';
import Workouts from '../pages/Workouts';
import RestDays from '../pages/RestDays';
import Resources from '../pages/Resources';
import Homes from '../pages/Homes';
import Warmups from '../pages/Warmups';
import NewVersion from '../pages/NewVersion';
import ProgramIntros from '../pages/ProgramIntros';
import HomeIntros from '../pages/HomeIntros';
import EndPages from '../pages/EndPages';
import BulkMigration from '../pages/BulkMigration';
import ProgramAccessReport from '../pages/ProgramAccessReport';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path={Path.LOGIN} element={<Login />} />

        <Route element={<PrivateRoute />}>
          <Route path={Path.DASHBOARD} element={<Dashboard />} />
          <Route path={Path.USERS} element={<Users />} />
          <Route path={Path.BULK_MIGRATION} element={<BulkMigration />} />
          <Route path={Path.PROGRAM_ACCESS_REPORT} element={<ProgramAccessReport />} />
          <Route path={Path.PROGRAM_INFO} element={<ProgramInfo />} />
          <Route path={Path.PROGRAM_EDIT} element={<ProgramEdit />} />
          <Route path={Path.CATEGORIES} element={<Categories />} />
          <Route path={Path.EQUIPMENTS} element={<Equipments />} />
          <Route path={Path.EXERCISES} element={<Exercises />} />
          <Route path={Path.RESOURCES} element={<Resources />} />
          <Route path={Path.VIDEOS} element={<Videos />} />
          <Route path={Path.REST_DAYS} element={<RestDays />} />
          <Route path={Path.HOMES} element={<Homes />} />
          <Route path={Path.WARMUPS} element={<Warmups />} />
          <Route path={Path.NEW_VERSION} element={<NewVersion />} />
          <Route path={Path.PROGRAM_INTROS} element={<ProgramIntros />} />
          <Route path={Path.HOME_INTROS} element={<HomeIntros />} />
          <Route path={Path.END_PAGES} element={<EndPages />} />
          {/* <Route path={Path.WORKOUTS} element={<Workouts />} /> */}
        </Route>

        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
